import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'
import { Button, Field, Input } from '../components/ui'

export function LoginPage() {
  const { login } = useAuth()
  const nav = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setErr(''); setBusy(true)
    try {
      await login(email, password)
      nav('/nodes', { replace: true })
    } catch (e: any) {
      setErr(e?.response?.data?.detail || e?.message || 'Не удалось войти')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-100 p-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-xl border border-neutral-200 shadow-sm p-8 space-y-5">
        <div className="text-center">
          <div className="w-10 h-10 rounded-lg bg-neutral-900 text-white flex items-center justify-center text-base font-semibold mx-auto mb-3">B</div>
          <h1 className="text-lg font-semibold tracking-tight">Beebro Hosting</h1>
          <p className="text-sm text-neutral-500 mt-1">Вход в панель управления</p>
        </div>
        <Field label="Электронная почта">
          <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required autoFocus />
        </Field>
        <Field label="Пароль">
          <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required />
        </Field>
        {err && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{err}</div>}
        <Button type="submit" disabled={busy} className="w-full justify-center">
          {busy ? 'Вход…' : 'Войти'}
        </Button>
      </form>
    </div>
  )
}
